// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__lmCan","image-wrapper":"styles-m__image-wrapper__2G6C7","text-wrapper":"styles-m__text-wrapper__3-JHR","headline":"styles-m__headline__1vH7k"};